export const getElementKey = ({
	key,
	pos,
	index,
}: {
	index: number;
	key?: string;
	pos?: string;
}): string | number => {
	if (key && pos) {
		return `${key}-${pos}-${index}`;
	}
	if (key) {
		return `${key}-${index}`;
	}
	if (pos) {
		return `${pos}-${index}`;
	}
	return index;
};
